export default "__VITE_ASSET__a4d31288__"